import React from 'react';
import {redirect, RouteObject} from 'react-router-dom';
import {DashboardPage} from '../modules/Dashboard';
import {OrderInvoicePage} from '../modules/OrderInvoice';
import {InvoicesPage} from '../modules/Invoices';
import {ReceiptsPage} from '../modules/Receipts';
import {InvoiceOrdersPage} from '../modules/InvoiceOrders';
import {PaymentPage} from '../modules/PaymentLink';
import {InviteFriendPage} from '../modules/InviteFriend';
import {SettingsPage} from '../modules/Settings';
import {TransfersPage} from '../modules/Transfers';
import {RegFormsPage} from '../modules/RegForms';
import AdminLogout from '../common/components/core/AdminLogout';
import UserRoot from '../common/components/core/UserRoot';
import SplashScreen from '../common/components/ui/SplashScreen';
import NoUserRoot from '../common/components/core/NoUserRoot';
import {
  ExternalLogin,
  ForgotPasswordPage,
  LoginAsAdminPage,
  LoginByPhonePage,
  LoginPage,
  RegisterPage,
  UpdatePasswordPage
} from '../modules/Auth';
import RedirectToForm101 from '../common/components/core/RedirectToForm101';
import {pathnames as P} from '../common/enums/pathnames';
import {PaypalPaymentStatusPage} from '../modules/PaypalPaymentStatus';

export const root: RouteObject[] = [
  {
    path: P.HOME,
    element: <UserRoot/>,
    children: [
      {
        path: P.HOME,
        element: <DashboardPage/>
      },
      {
        path: P.ORDER_INVOICE,
        element: <OrderInvoicePage/>
      },
      {
        path: P.INVOICES,
        element: <InvoicesPage/>
      },
      {
        path: P.RECEIPTS,
        element: <ReceiptsPage/>
      },
      {
        path: P.INVOICE_ORDERS,
        element: <InvoiceOrdersPage/>
      },
      {
        path: P.PAYMENT,
        element: <PaymentPage/>
      },
      {
        path: P.PAYMENT_ID,
        element: <PaymentPage/>
      },
      {
        path: P.INVITE_FRIEND,
        element: <InviteFriendPage/>
      },
      {
        path: P.SETTINGS,
        element: <SettingsPage/>
      },
      {
        path: P.REG_FORMS,
        element: <RegFormsPage/>
      },
      {
        path: P.TRANSFERS,
        element: <TransfersPage/>
      },
      {
        path: P.GO_TO_FORM101,
        element: <RedirectToForm101/>
      },
    ]
  },
  {
    path: P.HOME,
    element: <NoUserRoot/>,
    children: [
      {
        path: P.LOGIN,
        element: <LoginPage/>
      },
      {
        path: P.LOGIN_BY_PHONE,
        element: <LoginByPhonePage/>
      },
      {
        path: P.LOGIN_AS_ADMIN,
        element: <LoginAsAdminPage/>
      },
      {
        path: P.FORGOT_PASSWORD,
        element: <ForgotPasswordPage/>
      },
      {
        path: P.UPDATE_PASSWORD,
        element: <UpdatePasswordPage/>
      },
      {
        path: P.REGISTER,
        element: <RegisterPage/>
      },
      {
        path: P.PAYPAL_PAYMENT_STATUS,
        element: <PaypalPaymentStatusPage/>
      },
    ]
  },
  {
    path: P.EXTERNAL_LOGIN,
    element: <ExternalLogin/>
  },
  {
    path: P.EXTERNAL_ADMIN_LOGIN,
    element: <AdminLogout/>
  },
  {
    path: P.LOGOUT,
    element: <SplashScreen/>
  },
  /** Legacy Meteor client routes */
  {
    path: '/he/signin',
    loader: () => redirect(P.LOGIN),
    element: <SplashScreen/>
  },
  {
    path: '/he/signup',
    loader: () => {
      const params = new URLSearchParams(window.location.search);
      return redirect(`${P.REGISTER}?${params.toString()}`);
    },
    element: <SplashScreen/>
  },
  {
    path: '/he/reset-password',
    loader: () => redirect(P.FORGOT_PASSWORD),
    element: <SplashScreen/>
  },
  {
    path: '/he/user',
    loader: () => redirect(P.HOME),
    element: <SplashScreen/>
  },
  {
    path: '/he/admin',
    loader: () => redirect(P.HOME),
    element: <SplashScreen/>
  },
  {
    path: '/en/signin',
    loader: () => redirect(P.LOGIN),
    element: <SplashScreen/>
  },
  {
    path: '/en/signup',
    loader: () => {
      const params = new URLSearchParams(window.location.search);
      return redirect(`${P.REGISTER}?${params.toString()}`);
    },
    element: <SplashScreen/>
  },
  {
    path: '/en/reset-password',
    loader: () => redirect(P.FORGOT_PASSWORD),
    element: <SplashScreen/>
  },
  {
    path: '/en/user',
    loader: () => redirect(P.HOME),
    element: <SplashScreen/>
  },
  {
    path: '/en/admin',
    loader: () => redirect(P.HOME),
    element: <SplashScreen/>
  },
];
